import './LoginForm.css'
import { TabTitle } from '../../util/titleChanger'
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import axios from '../../helpers/axios';
import { Link, useNavigate } from 'react-router-dom';

export default function LoginForm() {
    TabTitle("Login");
    const navigate = useNavigate();

    const isUser = localStorage.getItem('login');

    const [user, setUser] = useState({ user_code: "", password: "" });

    const onChangeInput = (e) => {
        if(!e || !e.target) return;
        const { name, value } = e.target;
        setUser(prev=>({ ...prev, [name]: value }))
    }

    useEffect(() => {
        if (isUser) {
            navigate('/dashboard',{replace:true})
        }
    },[isUser,navigate])

    const login = async () => {
        if (user.user_code === "") return toast.error("User code is required!");
        if (user.password === "") return toast.error("Password is required!");

        try {
            await axios.post(`/user/login`, user).then(response => {
                const res = response.data.response;
                if (res.status === 200) {
                    localStorage.setItem("firstLogin", true);
                    localStorage.setItem("login", true);
                    localStorage.setItem('user_data', JSON.stringify(res.user))
                    localStorage.setItem("token", JSON.stringify(res.accesstoken))

                    setUser({ user_code: "", password: "" })
                    navigate('/dashboard')
                } else {
                    toast.error(res.data)
                }

            }).catch(err => {
                console.log("ERROR Message : ", err);
            })

        } catch (err) {
            toast.error(err.data)
        }
    }


    const loginSubmit = (e) => {
        e.preventDefault();
        login();
    }

    const keyDownSubmit = (e) => {
        if (e.key === "Enter") {
            login();
        }
    }

    if(isUser) return null;

    return (
        <div className='login-main'>
            <div className='center-box'>
                <div className="col-6 login-img">
                    <img src="/img/login_rightpenal.jpg" alt="right-panel-image" />
                </div>
                <div className="col-6 login-form">
                    <form onSubmit={loginSubmit} className="login-inner-form">
                        <h1 className="title">
                            Sign in to your account
                        </h1>

                        <div className='field'>
                            <label className='lable' htmlFor="user_code">User Code</label>
                            <input
                                type="text"
                                name="user_code"
                                id="user_code"
                                value={user.user_code}
                                placeholder='Enter User Code'
                                onChange={onChangeInput}
                                onKeyDown={(e) => keyDownSubmit(e)}
                            />
                        </div>

                        <div className='field'>
                            <label className='lable' htmlFor="password">Password</label>
                            <input
                                type="password"
                                name="password"
                                id="password"
                                placeholder="Enter Password"
                                value={user.password}
                                onChange={onChangeInput}
                                onKeyDown={keyDownSubmit} />
                        </div>

                        <div className="field">
                            <button
                                type="submit"
                                className="submit-btn">Sign In
                            </button>
                            <div className='forgot-link'>
                                <Link to={`/forgotpassword`}>Forgot Password?</Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div >
            <ToastContainer />
        </div >
    );
}